import md5 from 'md5';

export const generateLoginAsDetails = (userId: number, username: string) => {
  const timestamp = new Date().getTime();
  const hexKey = md5(`${username}${userId}${timestamp}pdhaf182`);

  return { timestamp, hexKey };
};
